var _defs, _path, _rect, _rect2, _rect3, _rect4, _path2, _circle, _rect5, _circle2, _path3, _path4, _circle3, _circle4, _circle5, _circle6, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _rect6, _rect7, _rect8, _rect9, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactMe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "undraw_quick_chat_re_bit5",
    xmlns: "http://www.w3.org/2000/svg",
    width: 792.102,
    height: 305.233,
    viewBox: "0 0 792.102 305.233",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #adb6c4;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #e4e4e4;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #c1d6f0;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #3f3d56;\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: #82abe1;\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: #4a5058;\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: #cacaca;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    className: "cls-1",
    d: "M261.315,119.745H0V205.53H9.9v22.437L32.334,205.53h228.98Z",
    transform: "translate(0 -19.44)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_603",
    "data-name": "Rectangle 603",
    className: "cls-2",
    width: 246.797,
    height: 68.628,
    transform: "translate(7.259 108.659)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_604",
    "data-name": "Rectangle 604",
    className: "cls-3",
    width: 118.827,
    height: 3.606,
    rx: 1.803,
    transform: "translate(29.085 129.356)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_605",
    "data-name": "Rectangle 605",
    className: "cls-3",
    width: 207.105,
    height: 3.606,
    rx: 1.803,
    transform: "translate(29.085 141.83)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_606",
    "data-name": "Rectangle 606",
    className: "cls-3",
    width: 206.902,
    height: 3.606,
    rx: 1.803,
    transform: "translate(29.085 154.305)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    className: "cls-2",
    d: "M692.073,614.449s1.246-26.1,26.781-23.066",
    transform: "translate(-253.114 -320.373)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    className: "cls-2",
    cx: 12.78,
    cy: 12.78,
    r: 12.78,
    transform: "translate(418.963 243.678)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_607",
    "data-name": "Rectangle 607",
    className: "cls-2",
    width: 3.608,
    height: 25.253,
    transform: "translate(429.663 277.979)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    className: "cls-4",
    cx: 103.281,
    cy: 103.281,
    r: 103.281,
    transform: "translate(455.378 47.559)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    className: "cls-2",
    d: "M755.526,447.722a27.33,27.33,0,0,1,41.951,0,30.377,30.377,0,1,0-42.948-1Q755.016,447.236,755.526,447.722Z",
    transform: "translate(-261.889 -288.592)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    className: "cls-2",
    d: "M853.438,447.723a27.33,27.33,0,0,1,41.951,0,30.377,30.377,0,1,0-42.947-1Q852.928,447.236,853.438,447.723Z",
    transform: "translate(-277.785 -288.592)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    className: "cls-4",
    cx: 10.449,
    cy: 10.449,
    r: 10.449,
    transform: "translate(493.801 116.365)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    className: "cls-4",
    cx: 10.449,
    cy: 10.449,
    r: 10.449,
    transform: "translate(575.814 116.365)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    className: "cls-5",
    cx: 12.151,
    cy: 12.151,
    r: 12.151,
    transform: "translate(472.085 164.51)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    className: "cls-5",
    cx: 12.151,
    cy: 12.151,
    r: 12.151,
    transform: "translate(611.817 164.51)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    className: "cls-5",
    d: "M659.724,181.886l-9.113,39.49L665.8,206.188Z",
    transform: "translate(-105.622 -29.528)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    className: "cls-4",
    d: "M710.918,351.422l-10.347-8.683.241,8.683H697.6l-.257-9.182-13.969,9.182h-5.848l19.713-12.957-.764-27.206-.57-20.548,3.206-.088.579,20.636.762,27.182,15.463,12.981Z",
    transform: "translate(-109.992 -47.181)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    className: "cls-4",
    d: "M652.893,351.422l-10.346-8.683.241,8.683h-3.2l-.257-9.182-13.97,9.182h-5.848l19.705-12.957-.763-27.206-.57-20.548,3.212-.088.579,20.636.755,27.182,15.463,12.981Z",
    transform: "translate(-100.573 -47.181)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    className: "cls-4",
    d: "M830.308,313.253c-2.834,0-5.334,2.2-7.005,5.582-1.473-5.084-4.568-8.62-8.183-8.62a5.493,5.493,0,0,0-.729.122c-1.389-5.428-4.619-9.235-8.383-9.235-5.033,0-9.113,6.8-9.113,15.188s4.08,15.188,9.113,15.188a5.511,5.511,0,0,0,.729-.123c1.389,5.428,4.619,9.235,8.383,9.235,2.834,0,5.334-2.2,7.005-5.583,1.473,5.084,4.568,8.62,8.183,8.62,5.033,0,9.113-6.8,9.113-15.188S835.341,313.253,830.308,313.253Z",
    transform: "translate(-270.131 -273.288)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    className: "cls-4",
    d: "M703.565,449.887l-56.894-9.228a29.061,29.061,0,0,0-8.663-.526,9.818,9.818,0,0,0-7.221,4.328,7.246,7.246,0,0,0,7.664,10.766c-3.106-.1-6.37-.167-9.125,1.268s-4.707,4.922-3.364,7.723a6.929,6.929,0,0,0,1.608,2.035,14.747,14.747,0,0,0,15.516,2.631c-2.094,3-6.251,3.45-9.846,4.145s-7.751,2.729-7.885,6.389c-.15,4.112,4.743,6.3,8.772,7.134a115.108,115.108,0,0,0,64.349-5.245A25.952,25.952,0,0,0,704.957,478a14.6,14.6,0,0,0-5.909-25.937",
    transform: "translate(-242.283 -295.833)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    className: "cls-4",
    d: "M998.123,497.4a115.111,115.111,0,0,0-42.865-48.28,25.946,25.946,0,0,0-6.54-3.191,14.6,14.6,0,0,0-17.179,20.31l-4.452-2.3,26.817,51.02a29.063,29.063,0,0,0,4.786,7.24,9.818,9.818,0,0,0,7.8,3.171,7.2,7.2,0,0,0,5.678-10.3,13.942,13.942,0,0,0,4.818,4.238c2.8,1.34,6.763.8,8.194-1.953a6.93,6.93,0,0,0,.66-2.508,14.748,14.748,0,0,0-7.221-13.983c3.659-.131,6.514,2.923,9.23,5.378s6.84,4.555,9.845,2.463C1001.071,506.344,999.873,501.119,998.123,497.4Z",
    transform: "translate(-291.267 -296.709)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    className: "cls-6",
    d: "M55.757,0H432.906V123.812H418.62v32.38l-32.38-32.38H55.757Z",
    transform: "translate(-9.052)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_608",
    "data-name": "Rectangle 608",
    className: "cls-2",
    width: 356.196,
    height: 99.05,
    transform: "translate(57.182 12.057)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_609",
    "data-name": "Rectangle 609",
    className: "cls-5",
    width: 171.499,
    height: 5.205,
    rx: 2.602,
    transform: "translate(85.825 40.975)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_610",
    "data-name": "Rectangle 610",
    className: "cls-5",
    width: 298.909,
    height: 5.205,
    rx: 2.602,
    transform: "translate(85.825 58.979)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_611",
    "data-name": "Rectangle 611",
    className: "cls-5",
    width: 298.616,
    height: 5.205,
    rx: 2.602,
    transform: "translate(85.825 76.983)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    className: "cls-7",
    d: "M1037.2,632.086H649.976a.992.992,0,1,1,0-1.983H1037.2a.992.992,0,1,1,0,1.983Z",
    transform: "translate(-246.115 -326.853)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactMe);
export default __webpack_public_path__ + "static/media/Contact-me.7f627f76decdb80206b450d2ca368076.svg";
export { ForwardRef as ReactComponent };